import React, {useEffect, useState} from "react";
import FormattingGroup from "@common/components/forms/rich-text-form-field/tools/formatting-group";
import ToolsSeparator from "@common/components/forms/rich-text-form-field/tools/tools-separator";
import TextStyleDropdown from "@common/components/forms/rich-text-form-field/tools/text-style-dropdown";
import MediaGroup from "@common/components/forms/rich-text-form-field/tools/media-group";
import HistoryGroup from "@common/components/forms/rich-text-form-field/tools/history-group";
import {
    MediaOptions,
    RichTextTool,
    TextFormats,
    TextOptions,
    HistoryOptions,
} from "@common/components/forms/rich-text-form-field/tools/tools-types.enum";
import {ToolbarActions} from "@common/components/forms/rich-text-form-field/plugins/toolbar-plugin";

interface RichTextToolbarProps extends ToolbarActions {
    isActiveToolbar: boolean;
    hiddenOptions?: Array<RichTextTool>;
}

const RichTextToolbar: React.FC<RichTextToolbarProps> = (props) => {
    const [selectedOption, setSelectedOption] = useState("paragraph");
    const {
        onFormatChange,
        onInsertLink,
        onRemoveLink,
        onInsertImage,
        onChangeBlockType,
        onUndo,
        onRedo,
        activeFormats,
        currentBlockType,
        currentLinkUrl,
        isActiveToolbar,
        hiddenOptions = [],
    } = props;

    // Aktualizuj widoczny typ tekstu w dropdownie na podstawie faktycznego typu bloku w edytorze
    useEffect(() => {
        if (currentBlockType && currentBlockType !== selectedOption) {
            setSelectedOption(currentBlockType);
        }
    }, [currentBlockType]);

    const hasStyleDropdown: boolean = !hiddenOptions.includes(TextOptions.HEADING1) ||
        !hiddenOptions.includes(TextOptions.HEADING2) ||
        !hiddenOptions.includes(TextOptions.BULLET) ||
        !hiddenOptions.includes(TextOptions.NUMBERED) ||
        !hiddenOptions.includes(TextOptions.DASH) ||
        !hiddenOptions.includes(TextOptions.PARAGRAPH)

    const hasFormattingGroup: boolean = !hiddenOptions.includes(TextFormats.BOLD) ||
        !hiddenOptions.includes(TextFormats.ITALIC) ||
        !hiddenOptions.includes(TextFormats.UNDERLINE);

    const hasMediaGroup: boolean = !hiddenOptions.includes(MediaOptions.LINK) ||
        !hiddenOptions.includes(MediaOptions.IMAGE);

    const hasHistoryGroup: boolean = !hiddenOptions.includes(HistoryOptions.UNDO) ||
        !hiddenOptions.includes(HistoryOptions.REDO);

    if (!isActiveToolbar) return null;

    return (
        <div className="absolute inset-x-0 -top-16 bottom-0 z-50 flex items-start justify-center pointer-events-none">
            <div
                className="sticky top-4 rich-text-toolbar w-fit bg-surface-level-1 rounded-[103px] shadow-lg p-1 flex items-center gap-1 pointer-events-auto">
                {hasStyleDropdown && (
                    <TextStyleDropdown
                        currentBlockType={currentBlockType}
                        onChangeBlockType={onChangeBlockType}
                        hiddenOptions={hiddenOptions}
                    />
                )}
                {hasStyleDropdown && hasFormattingGroup && <ToolsSeparator/>}
                {hasFormattingGroup && (
                    <FormattingGroup
                        activeFormats={activeFormats}
                        onFormatChange={onFormatChange}
                        hiddenOptions={hiddenOptions}
                    />
                )}
                {hasMediaGroup && <ToolsSeparator/>}
                {hasMediaGroup && (
                    <MediaGroup
                        isLinkActive={activeFormats.hasLink}
                        currentLinkUrl={currentLinkUrl}
                        onInsertLink={onInsertLink}
                        onRemoveLink={onRemoveLink}
                        onInsertImage={onInsertImage}
                        hiddenOptions={hiddenOptions}
                    />
                )}
                {hasHistoryGroup && <ToolsSeparator/>}
                {hasHistoryGroup && (
                    <HistoryGroup
                        onUndo={onUndo}
                        onRedo={onRedo}
                    />
                )}
            </div>
        </div>
    );
};

export default RichTextToolbar;
